export const Settings = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M12 15.25C13.7949 15.25 15.25 13.7949 15.25 12C15.25 10.2051 13.7949 8.75 12 8.75C10.2051 8.75 8.75 10.2051 8.75 12C8.75 13.7949 10.2051 15.25 12 15.25Z" stroke="currentColor" strokeWidth="2" />
			<path d="M19.2 13.55C19.3 13.05 19.3 12.95 19.3 12C19.3 11.05 19.3 10.95 19.2 10.45L21 9.05L19.3 6.1L17.15 6.95C16.45 6.35 16.35 6.3 15.5 5.85L15.2 3.6H8.8L8.5 5.85C7.65 6.3 7.55 6.35 6.85 6.95L4.7 6.1L3 9.05L4.8 10.45C4.7 10.95 4.7 11.05 4.7 12C4.7 12.95 4.7 13.05 4.8 13.55L3 14.95L4.7 17.9L6.85 17.05C7.55 17.65 7.65 17.7 8.5 18.15L8.8 20.4H15.2L15.5 18.15C16.35 17.7 16.45 17.65 17.15 17.05L19.3 17.9L21 14.95L19.2 13.55Z" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};
export const SettingsFilled = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M19.2 13.55C19.3 13.05 19.3 12.95 19.3 12C19.3 11.05 19.3 10.95 19.2 10.45L21 9.05L19.3 6.1L17.15 6.95C16.45 6.35 16.35 6.3 15.5 5.85L15.2 3.6H8.8L8.5 5.85C7.65 6.3 7.55 6.35 6.85 6.95L4.7 6.1L3 9.05L4.8 10.45C4.7 10.95 4.7 11.05 4.7 12C4.7 12.95 4.7 13.05 4.8 13.55L3 14.95L4.7 17.9L6.85 17.05C7.55 17.65 7.65 17.7 8.5 18.15L8.8 20.4H15.2L15.5 18.15C16.35 17.7 16.45 17.65 17.15 17.05L19.3 17.9L21 14.95L19.2 13.55Z" fill="currentColor" />
			<path d="M12 15.25C13.7949 15.25 15.25 13.7949 15.25 12C15.25 10.2051 13.7949 8.75 12 8.75C10.2051 8.75 8.75 10.2051 8.75 12C8.75 13.7949 10.2051 15.25 12 15.25Z" fill="white" />
		</svg>
	);
};
